/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzs_Staatsexamen_Jura19Inputs */

const en__field_enum_mzs_staatsexamen_jura19 = /** @type {(inputs: _Field_Enum_Mzs_Staatsexamen_Jura19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Jura`)
};

const de__field_enum_mzs_staatsexamen_jura19 = /** @type {(inputs: _Field_Enum_Mzs_Staatsexamen_Jura19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Jura`)
};

/**
* | output |
* | --- |
* | "Staatsexamen Jura" |
*
* @param {_Field_Enum_Mzs_Staatsexamen_Jura19Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzs_staatsexamen_jura19 = /** @type {((inputs?: _Field_Enum_Mzs_Staatsexamen_Jura19Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzs_Staatsexamen_Jura19Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzs_staatsexamen_jura19(inputs)
	return de__field_enum_mzs_staatsexamen_jura19(inputs)
});
export { _field_enum_mzs_staatsexamen_jura19 as "_field_enum_MZS_STAATSEXAMEN_JURA" }